/* eslint-disable no-unused-vars */
import { useLayoutEffect, useState } from 'react'

function usePersistentExpansion() {
  const [expanded, setExpanded] = useState(true)
  useLayoutEffect(() => {
    const storedwidth = localStorage?.getItem('sidebar-width')
    if (storedwidth) {
      document.documentElement.style.setProperty('--sidebar-width', storedwidth)
      storedwidth === '80px' && setExpanded(false)
    }
  }, [])

  const toggleExpand = () => {
    const currentWidth = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-width')
    const parsed = parseInt(currentWidth)
    if (parsed >= 350) {
      document.documentElement.style.setProperty('--sidebar-width', '80px')
      localStorage.setItem('sidebar-width', '80px')
      setExpanded(false)
    } else {
      document.documentElement.style.setProperty('--sidebar-width', '350px')
      localStorage.setItem('sidebar-width', '350px')
      setExpanded(true)
    }
  }
  return { toggleExpand, expanded }
}
export default usePersistentExpansion
